const getTotal = order =>
    order.reduce((acc, { price, quantity }) => {
        price = isNaN(price) ? 0 : price
        return acc + price * quantity
    }, 0)

export default getTotal
